import React from "react";
import { Skeleton } from "@heroui/skeleton";

export default function TradingViewWidgetSkeleton() {
  return (
    <div className="p-4 mt-5 bg-white shadow-md rounded-lg border mb-4 pb-10">
      {/* Title Placeholder */}
      <Skeleton className="w-3/4 sm:w-1/2 md:w-1/3 h-10 mb-4 rounded-lg" />
      {/* Widget Placeholder */}
      <Skeleton className="w-full  h-400 sm:h-450 md:h-450 lg:h-550  rounded" />
      {/* Additional Placeholders for buttons or tabs */}
      <div className="flex mt-4 space-x-2">
        <Skeleton className="  h-400 sm:h-400 md:h-400 lg:h-300 w-full rounded" />
      </div>
    </div>
  );
}
